import { useEffect } from "react";

const useSecurityRestrictions = () => {
  useEffect(() => {

    // Disable right-click
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    // Disable common browser shortcuts
    const handleKeyDown = (event) => {
      // F12 - Windows
      if (event.key === "F12") {
        event.preventDefault();
        return;
      }

      // Ctrl + Shift + I / Cmd + Option + I
      if (
        (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "i") ||
        (event.metaKey && event.altKey && event.key.toLowerCase() === "i")
      ) {
        event.preventDefault();
        return;
      }

      // Ctrl + Shift + J / Cmd + Option + J
      if (
        (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "j") ||
        (event.metaKey && event.altKey && event.key.toLowerCase() === "j")
      ) {
        event.preventDefault();
        return;
      }

      // Ctrl + U / Cmd + Option + U
      if (
        (event.ctrlKey && event.key.toLowerCase() === "u") ||
        (event.metaKey && event.altKey && event.key.toLowerCase() === "u")
      ) {
        event.preventDefault();
        return;
      }

      // Ctrl + Shift + C / Cmd + Shift + C
      if (
        (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "c") ||
        (event.metaKey && event.shiftKey && event.key.toLowerCase() === "c")
      ) {
        event.preventDefault();
        return;
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };

  }, []);
};

export default useSecurityRestrictions;